import enIconUrl from '@assets/icons/EnglishUSFlag.svg'
import ruIconUrl from '@assets/icons/RussianFlag.svg'
// import idIconUrl from '@assets/icons/IndonesianFlag.svg'

export const SUPPORTED_LANGUAGES = Object.freeze([
    {
        code: 'en',
        language: 'English',
        iconUrl: enIconUrl
    },
    {
        code: 'ru',
        language: 'Russian',
        iconUrl: ruIconUrl
    },
    // {
    //     code: 'id',
    //     language: 'Bahasa Indonesia',
    //     iconUrl: idIconUrl
    // },
])